module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bgImage,
      "aspect-ratio": "2.75",
      "height": "170"
    }
  }, [_c('center', [(_vm.qr) ? _c('v-img', {
    staticClass: "elevation-20 mt-2",
    staticStyle: {
      "border": "solid 2px black"
    },
    attrs: {
      "width": "150px",
      "height": "150px",
      "src": _vm.qr
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._t("card-title", function() {
    return [_c('v-card-title', {
      staticClass: "subheading"
    }, [_vm._v("\n      Share: " + _vm._s(_vm.link.title) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "href": _vm.link.url,
        "title": _vm.link.title,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1)]
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-alert', {
    staticClass: "pa-2 mx-3",
    attrs: {
      "outline": "",
      "value": true,
      "type": "info"
    }
  }, [_vm._v("\n    Point your phone's camera at this code to open the link\n  ")]), _vm._v(" "), _c('v-card-text', [_c('copy-text-field', {
    attrs: {
      "text-to-copy": _vm.link.url,
      "label": "Copy link to clipboard"
    }
  }), _vm._v(" "), (_vm.email || _vm.phone || _vm.firstName) ? _c('v-list', {
    staticClass: "mt-0 pa-0",
    attrs: {
      "dense": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "mt-0 py-0 overline"
  }, [_vm._v("Contact information")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName) + "\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.phone)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.email)
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success",
      "href": _vm.whatsappIt(_vm.phone, _vm.link.url),
      "target": "_blank",
      "block": ""
    }
  }, [_vm._v("Whatsapp\n      "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "href": _vm.mailIt(_vm.email, _vm.link),
      "target": "_blank",
      "block": ""
    }
  }, [_vm._v("Open in mail\n      "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), (_vm.canShare) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.share
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a864618","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/ShareCard.vue
// module id = 1493
// module chunks = 9